import { Context } from "@nuxt/types/app";
import { isFinite } from "lodash-es";

interface ByteFromKbPlugin {
  getBytesFromKB(number: number): number;
}

export default function (context: Context): ByteFromKbPlugin {
  function getBytesFromKB(number: number): number {
    if (!isFinite(number)) {
      return 0;
    }

    return number * 1024;
  }

  return { getBytesFromKB };
}
